module.exports = __webpack_public_path__ + "home/en-US/js/home-header/images/child_safe_mobile-36db3ab95e6e50499ba8de922e7e2470.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/home-header/images/child_safe_mobile.png
// module id = b6jU
// module chunks = 0